import { buildAgentTheme, buildAppTheme } from "./buildTheme"
import { THEME_DEFAULTS } from "./tokens"

export * from "./tokens"
export { buildAgentTheme, buildAppTheme }

// Static fallbacks built from the default tokens. Runtime consumers should take the
// themed variants from AppearanceContext (`useAgentTheme`) so user themes apply.
export const baseTheme = buildAppTheme(THEME_DEFAULTS)
export const jarvisTheme = buildAgentTheme(THEME_DEFAULTS, "jarvis")
export const fridayTheme = buildAgentTheme(THEME_DEFAULTS, "friday")
